module.exports = __webpack_public_path__ + "img/wedo_pict04.3496b7eb.png";